// Every UI string ball.io shows (ui-flow §13, ui-qol §13), plus the system dialogs (ui-flow §9),
// the NOTICE reactions (protocol §5.6) and the money-room screens (money-mode §2, §4, §7). All
// copy is original to ball.io. English only in v1, but every string goes through `t(key)`
// (ui/i18n/t.ts) so another table can slot in later.
//
// `{x}` marks a placeholder that `t(key, { x })` fills in.

export const EN = {
  // --- play card (ui-qol §4.1) ---
  'menu.nick.placeholder': 'Nickname',
  'menu.nick.label': 'Nickname',
  'menu.play': 'Play',
  'menu.skins': 'Skins',
  'menu.hint.desktop.1': 'Move the mouse to steer your cell',
  'menu.hint.desktop.2': '{space} splits you · {w} ejects mass',
  'menu.hint.touch.1': 'Drag to steer your cell',
  'menu.hint.touch.2': 'Tap ✂ to split · tap ● to eject',
  'menu.key.space': 'Space',
  'menu.key.w': 'W',
  'menu.connecting': 'Connecting…',
  'menu.online.one': '{n} player online',
  'menu.online.other': '{n} players online',
  'menu.full.title': 'Servers are full',
  'menu.full.retryIn': 'Retrying in {s}s…',
  'menu.full.retrying': 'Retrying…',
  'menu.drawOwn': 'Draw your own!',
  'menu.help': 'How to play',

  // --- mode card (ui-qol §4.2) ---
  'modes.title': 'Pick a game mode',
  'modes.ffa': 'Free-for-all',
  'modes.battleroyale': 'Battle Royale',
  'modes.teams': 'Teams',
  'modes.experimental': 'Experimental',
  'modes.soon': 'soon',

  // --- party (ui-flow §10, ui-qol §4.3) ---
  'party.title': 'Party mode',
  'party.blurb': 'Play in the same arena as your friends',
  'party.create': 'Create',
  'party.join': 'Join',
  'party.leave': 'Leave party',
  'party.enterCode': 'Type the code your friend sent you',
  'party.codePlaceholder': 'Party code',
  'party.creating': 'Making your room…',
  'party.joining': 'Joining…',
  'party.inParty': 'IN PARTY',
  'party.full': 'That party is full.',
  'party.notFound': "Couldn't find that party. Check the code?",
  'party.confirmJoin.title': 'Join party {code}?',
  'party.confirmJoin.body': 'Someone sent you a party link.',
  'party.notNow': 'Not now',
  'party.confirmLeave.title': 'Leave the party?',
  'party.confirmLeave.body': "You'll go back to public rooms.",
  'party.copied': 'Link copied!',
  'party.joinedToast': '{name} joined the party',
  'party.leftToast': '{name} left the party',
  'party.members': '{n} in the room',
  'party.code': 'Party {code}',
  'party.linkLabel': 'Your party link',
  'party.createFailed': "Couldn't make a room right now. Try again soon.",
  'party.ended': 'That party has ended.',

  // --- HUD (ui-qol §2) ---
  'hud.leaderboard': 'Leaderboard',
  'hud.unnamed': 'Unnamed cell',
  'hud.score': 'Score: {n}',
  'hud.teamMass': 'Team mass',
  'hud.left': '{n} left',
  'hud.laggy': 'Laggy connection',
  'hud.spectateHint': 'Press Q to switch the spectate camera',
  'hud.spectateHint.touch': 'Tap the camera button to switch the spectate camera',
  'hud.stats': '{fps} fps · {ping} ms',
  'hud.freeLook': 'free look',

  // --- round results (ui-qol §7) ---
  'summary.title': 'Round results',
  'summary.pellets': 'pellets eaten',
  'summary.topMass': 'top mass',
  'summary.timeAlive': 'time alive',
  'summary.boardTime': 'time on the board',
  'summary.ballsEaten': 'cells eaten',
  'summary.bestRank': 'best rank',
  'summary.noRank': '—',
  'summary.continue': 'Continue',
  'summary.friends.1': 'Share a link and play together',
  'summary.friends.2': 'Then press Play to join',
  'summary.createLink': 'Create party link',
  'summary.graph': 'Your mass over this life',

  // --- settings and skins (ui-qol §5) ---
  'settings.title': 'Settings',
  'settings.region': 'Region',
  'settings.regionHeader': '— Choose a region —',
  'settings.graphics': 'Graphics',
  'settings.graphicsHeader': '— Graphics —',
  'settings.graphicsItem': 'Graphics: {level}',
  'settings.more': 'More options',
  'settings.watch': 'Spectate',
  'settings.watchDisabled': 'Finish your round first',
  'settings.hideSkins': 'Hide skins',
  'settings.hideNames': 'Hide names',
  'settings.plainColors': 'Plain colors',
  'settings.showMass': 'Show mass',
  'settings.darkMode': 'Dark mode',
  'settings.skipSummary': 'Skip round summary',
  'settings.minimap': 'Show minimap',
  'settings.minimapPlayers': 'Show bigger players on minimap',
  'settings.stats': 'Show FPS & ping',
  'settings.holdEject': 'Hold W to keep shooting',
  'settings.gameSounds': 'Game sounds',
  'settings.menuSounds': 'Menu sounds',
  'settings.volume': 'Volume',
  'settings.reduceMotion': 'Reduce motion',
  'settings.motion.system': 'Like my device',
  'settings.motion.on': 'On',
  'settings.motion.off': 'Off',
  'settings.style': 'Arena style',
  'settings.style.classic': 'Classic',
  'settings.style.sketch': 'Sketch',
  'settings.labelCurrency': 'Money labels',
  'settings.currency.auto': 'Room default',
  'settings.currency.USD': 'US dollars',
  'settings.currency.SOL': 'SOL',
  'settings.touchSteer': 'Touch steering',
  'settings.touchJoystick': 'Joystick',
  'settings.touchFollow': 'Follow finger',
  'settings.touchStop': 'Stop when finger lifts',
  'settings.quality.auto': 'Auto',
  'settings.quality.sharp': 'Sharp',
  'settings.quality.high': 'High',
  'settings.quality.medium': 'Medium',
  'settings.quality.low': 'Low',
  'settings.quality.verylow': 'Very low',
  'settings.regionAuto': 'Auto (fastest)',
  'settings.regionItem': '{name} ({players})',
  'settings.version': 'ball.io v{version}',
  'skins.title': 'Skins',
  'skins.none': 'None',
  'skins.teamsNote': 'Skins are hidden in Teams',

  // --- first-play controls hint and help (ui-qol §9) ---
  'onboard.move': 'Move the mouse to steer',
  'onboard.split': 'Split in two',
  'onboard.eject': 'Eject a bit of mass',
  'onboard.touch.move': 'Drag to steer',
  'onboard.touch.split': 'Tap to split',
  'onboard.touch.eject': 'Tap to eject',
  'onboard.cashOut': 'Hold to cash out your value',
  'onboard.touch.cashOut': 'Hold the $ button to cash out',
  'onboard.close': 'Hide these tips',
  'help.title': 'How to play',
  'help.again': 'Show the controls hint again',
  'help.againDone': 'The hint will show on your next spawn.',
  'help.mouse': 'Mouse',
  'help.mouse.do': 'steer your cell',
  'help.space.do': 'split in two',
  'help.w.do': 'eject a bit of mass (hold it with “Hold W to keep shooting”)',
  'help.q.do': 'switch the spectate camera',
  'help.esc': 'Esc',
  'help.esc.do': 'open the menu',
  'help.wheel': 'Mouse wheel',
  'help.wheel.do': 'zoom in and out',
  'help.cashOut.do': 'money arenas: hold to cash out',
  'help.touch': 'On a phone: drag to steer, tap ✂ to split, tap ● to eject, pinch to zoom.',

  // --- Battle Royale and Team Rush (ui-flow §6.8, §10.6–10.7; M3) ---
  'br.waiting': 'Rounding up players · {ready}/{needed}',
  'br.starting': 'Starting in {s}',
  'br.shrinksIn': 'Zone shrinks in {s}',
  'br.shrinking': 'Zone shrinking!',
  'br.outside': 'Get back in the zone!',
  'br.win': 'Winner winner!',
  'br.placed': 'You placed #{n}',
  'br.watch': 'Watch',
  'br.noStandings': 'No standings yet',
  'br.back': 'Back to menu',
  'teams.win': '{team} team wins!',
  'teams.tie': 'Dead even!',
  'teams.again': 'Rematch',
  'teamrush.left': '{mm:ss} left',
  'teamrush.respawn': 'Respawning in {s}',

  // --- boot, how-to, footer (ui-flow §3, ui-qol §4) ---
  'boot.finding': 'Finding a room…',
  'howto.title': 'How to play',
  'howto.move': 'Steer with your mouse. Eat smaller cells and pellets.',
  'howto.split': 'Space splits you in two. Use it to catch prey.',
  'howto.shoot': 'W shoots a bit of your mass. Feed friends or the spiky ones.',
  'howto.move.touch': 'Drag to steer your cell. Eat smaller cells and pellets.',
  'howto.split.touch': 'Tap ✂ to split in two. Use it to catch prey.',
  'howto.shoot.touch': 'Tap ● to shoot a bit of your mass. Feed friends or the spiky ones.',
  'opensource.title': 'Open source',
  'opensource.body': 'ball.io is free software. Read the code, host your own arena, send a fix.',
  'opensource.link': 'View the source',
  'footer.about': 'About',
  'footer.privacy': 'Privacy',
  'footer.source': 'Source code',
  'footer.version': 'v{version}',

  // --- money arenas (money-mode §1.2, §2, §4, §7) ---
  // --- practice arena (money-mode §1.4) ---
  'practice.title': 'Practice arena',
  'practice.free': 'FREE',
  'practice.badge': 'PRACTICE',
  'practice.blurb': 'The {stake} money game with play money, bots included. No sign-in.',
  'practice.join': 'Practice · {players}',
  'practice.joining': 'Joining the practice arena…',
  'practice.inRoom': 'You are in the practice arena',
  'practice.startWith': 'Press Play: you start with {value} of play money',
  'practice.closed': 'The practice arena is closed right now.',
  'practice.again': 'Practice again',
  'practice.playForReal': 'Play for real · {stake}',
  'practice.playForRealSoon': 'Real money · coming soon',
  'practice.cashout.title': 'Practice cash-out',
  'practice.cashout.caption': 'Practice cash-out',
  'practice.cashout.playMoney': '(play money)',

  'money.title': 'Play for money',
  'money.blurb': 'Buy in, eat players to take their value, hold {key} to cash out.',
  'money.blurbTouch': 'Buy in, eat players to take their value, hold $ to cash out.',
  'money.blurbArena':
    'Buy in, cut a trail to take that whole bag, hold {key} outside your land to cash out.',
  'money.blurbArenaTouch':
    'Buy in, cut a trail to take that whole bag, hold $ outside your land to cash out.',
  'money.test': 'TEST MONEY',
  'money.testNote': 'Test money only: nothing real is paid or won.',
  'money.loading': 'Looking for money arenas…',
  'money.closed': 'Money arenas are closed right now.',
  'money.soon': 'COMING SOON',
  'money.soonBlurb': 'Real-money arenas are on the way. Free play stays free: no login needed.',
  'money.fullWait': 'Every {stake} arena is full.',
  'money.fullRetryIn': 'Trying again in {s}s…',
  'money.fullRetrying': 'Trying again…',
  'money.cancel': 'Cancel',
  'money.stakeItem': '{stake} arena',
  'money.stakePlayers': '{n}/{max} playing',
  'money.stakeFull': 'full',
  'money.joining': 'Joining the {stake} arena…',
  'money.inRoom': 'You are in the {stake} arena',
  'money.roomPlayers': '{n} playing here',
  'money.buyIn': 'Buy-in {stake} · you start with {value}',
  'money.buyInShort': 'Buy-in {stake}',
  'money.buying': 'Buying in…',
  'money.inLife': 'Hold {key} to cash out',
  'money.leave': 'Back to free play',
  'money.otherStake': 'Pick another stake',
  'money.value': 'Value: {v}',
  'money.holdHint': 'Hold {key} to cash out',
  'money.holdTouch': 'Hold to cash out',
  'money.cashingOut': 'Cashing out… {pct}%',
  'money.tooEarly': 'You can cash out in {s}s',
  'money.valueLost': 'Value lost: {v}',
  'money.cashout.title': 'Cashed out!',
  'money.cashout.received': 'You received',
  'money.cashout.delayed':
    'Your payout is held for a quick review. It will arrive once the check clears.',
  'money.refused.title': "Can't start that life",
  'money.error.title': 'Money arena problem',
  'money.error.ticketRequired': 'This arena needs a buy-in before you can play.',
  'money.error.ticketInvalid': "That buy-in couldn't be used. Please buy in again.",
  'money.error.ticketUsed': 'That buy-in was already used. Each life needs a new one.',
  'money.error.moneyLifeActive':
    'You already have a money life running somewhere. Cash it out or finish it first.',
  'money.error.stakeNotOffered': "That stake isn't offered in this arena.",
  'money.ticketKept': 'Your unused {stake} entry is kept for your next Play.',
  'money.frozenLife': 'Your money life is frozen here: {v}. Press Play to take it back ({s}s)',
  'money.frozenLifeSoon': 'Your money life is frozen here: {v}, driving out to cash out…',
  'money.lifeBusy': 'Your money life is still running. You can play again once it ends.',
  'money.exit.cashedOut': 'Your frozen money life was cashed out automatically: {v}',
  'money.exit.eaten': 'Your frozen money life was eaten before it could cash out.',
  'money.idleWarning':
    'Move, or your money life freezes in {s}s (then it cashes out automatically).',
  'money.idleFrozen':
    'Frozen for inactivity: your cells no longer move and can be eaten. Auto cash-out in {s}s.',
  'money.error.disabled': 'Money arenas are closed right now.',
  'money.error.full': 'Every arena at this stake is full. Try again in a moment.',
  'money.error.network': "Couldn't reach the money arenas. Check your connection.",
  'money.error.disconnected': 'The connection to the money arena dropped.',
  'money.error.buyIn.badRequest': "The buy-in request wasn't accepted.",
  'money.error.buyIn.invalidAccount': "Your test account wasn't accepted.",
  'money.error.buyIn.paymentFailed': "The payment didn't go through. Nothing was charged.",
  'money.error.buyIn.stakeNotOffered': "That stake isn't offered right now.",
  'money.error.buyIn.rateLimited': 'Too many buy-ins in a row. Wait a minute and try again.',
  'money.error.buyIn.priceUnavailable': "The SOL price isn't available right now. Try again soon.",
  'money.error.buyIn.shuttingDown': 'The server is restarting. Nothing was charged.',
  'money.error.buyIn.walletUnlinked':
    'Your money wallet was removed from your sign-in, so money games are paused for this account. Nothing was charged. Contact support.',
  'money.error.buyIn.unavailable': "Buy-ins aren't available on this server.",
  'money.error.buyIn.network': "Couldn't reach the server to buy in. Nothing was charged.",
  'money.error.buyIn.authRequired': 'Sign in to buy in. Nothing was charged.',
  'money.error.buyIn.authInvalid':
    'Your sign-in expired. Sign in again to buy in. Nothing was charged.',
  'money.error.buyIn.banned': 'This account is suspended from money arenas.',
  'money.error.ticketNotYours':
    'That entry was bought with a different account. Sign in with that account to use it, or buy in again.',
  'money.error.auth': 'Sign in again to keep playing for money.',
  'money.error.signIn': 'Sign in to play for money.',
  'money.error.username': 'Pick a username before your first money game.',

  // --- common ---
  // --- sign-in and account (money card account row, username dialog; protocol §3.2) ---
  'account.signIn': 'Sign in',
  'account.signingIn': 'Signing in…',
  'account.signInHint': 'Sign in with email, Google, X or a Solana wallet to play for money.',
  'account.unavailable': "Sign-in isn't available right now. Try again later.",
  'account.signedInAs': 'Signed in as {name}',
  'account.signedIn': 'Signed in',
  'account.pickUsername': 'Pick a username',
  'account.walletLabel': 'Wallet',
  'account.walletPending': 'Setting up your wallet…',
  'account.walletProblem.unlinked':
    'This wallet was removed from your sign-in, so money games are paused. Contact support.',
  'account.walletProblem.taken':
    'This wallet is already used by another ball.io account. Contact support to play for money.',
  'account.walletProblem.setupFailed':
    "Your wallet couldn't be set up. Sign out and sign in again to play for money.",
  'account.walletKind.embedded': 'built-in',
  'account.walletKind.external': 'external',
  'account.walletKindTitle.embedded':
    'A Solana wallet made for you at sign-in. Money games use it for buy-ins and winnings.',
  'account.walletKindTitle.external':
    'The Solana wallet you signed in with. Money games use it for buy-ins and winnings.',
  'account.copyWallet': 'Copy wallet address',
  'account.walletCopied': 'Wallet address copied',
  'account.signOut': 'Sign out',
  'account.signedOut': 'Signed out. Free play needs no account.',
  'account.bannedUntil': 'Suspended until {date}',
  'account.bannedForever': 'This account is suspended.',
  'account.expired.title': 'Please sign in again',
  'account.expired.body':
    "Your sign-in expired or wasn't accepted. Sign in again to play for money. Free play needs no account.",
  'account.banned.title': 'Account suspended',
  'account.banned.body':
    "This account can't play in money arenas right now. Free play is still open.",
  'account.failed': "Couldn't sign you in. Please try again.",
  'username.title': 'Pick a username',
  'username.body': 'It shows in money arenas and on leaderboards. You can set it only once.',
  'username.placeholder': 'Username',
  'username.label': 'Username',
  'username.rules': '3–15 letters, digits or _',
  'username.save': 'Save',
  'username.saving': 'Saving…',
  'username.later': 'Later',
  'username.problem.tooShort': 'At least 3 characters.',
  'username.problem.tooLong': 'At most 15 characters.',
  'username.problem.badChars': 'Only letters, digits and _ are allowed.',
  'username.problem.reserved': 'That name is reserved. Pick another.',
  'username.taken': 'That username is taken. Try another one.',
  'username.alreadySet': 'Your username is already set.',
  'username.failed': "Couldn't save it. Check your connection and try again.",
  'username.saved': 'Username saved: {name}',
  'common.copy': 'Copy',
  'common.play': 'Play',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.ok': 'OK',
  'common.retry': 'Try again',
  'common.close': 'Close',
  'common.copyFallback': 'Press Ctrl+C (⌘+C on Mac) to copy',

  // --- toasts ---
  'toast.padOn': 'Controller ready',
  'toast.padOff': 'Controller unplugged',
  'toast.brStart': 'Your battle is starting!',

  // --- system dialogs (ui-flow §9) ---
  'dialog.connecting.title': 'Finding a room…',
  'dialog.cant_reach.title': "Can't reach the server",
  'dialog.cant_reach.body': 'Check your connection, then try again.',
  'dialog.cant_reach.button': 'Retry',
  'dialog.connection_lost.title': 'Connection lost',
  'dialog.connection_lost.body': "Your cell didn't make it. Sorry!",
  'dialog.connection_lost.button': 'Reconnect',
  'dialog.money_connection_lost.title': 'Connection lost',
  'dialog.money_connection_lost.body':
    'Your money life is still in the arena, frozen: it stops moving and its trail can still be ' +
    'cut. Press Play when you are back to take it over again. If you don’t, it drives itself ' +
    'out of its land and cashes out to you.',
  'dialog.money_connection_lost.button': 'OK',
  'dialog.room_full.title': 'Every room is full',
  'dialog.room_full.body': 'Give it a moment and try again.',
  'dialog.room_full.button': 'Try again',
  'dialog.outdated.title': 'ball.io got an update',
  'dialog.outdated.body': 'Refresh to get the new version.',
  'dialog.outdated.button': 'Refresh',
  'dialog.kicked.title': 'You were removed from this server.',
  'dialog.kicked.button': 'OK',
  'dialog.too_many.title': 'Too many tabs',
  'dialog.too_many.body': 'Close some ball.io tabs on this network, then try again.',
  'dialog.too_many.button': 'Try again',

  // --- NOTICE reactions (protocol §5.6) ---
  'notice.spectateFull': 'Spectator seats are full.',
  'notice.partyJoined': '{name} joined the party',
  'notice.partyLeft': '{name} left the party',
  'notice.roomClosing': 'This room closes in {mm:ss}',
  'notice.serverRestart': 'Server restarting in {s}s',
  'notice.idleWarning': 'Move, or your money life freezes in {s}s',
  'notice.idleFrozen': 'Frozen for inactivity: auto cash-out in {s}s',
  'notice.nameRejected': "That name isn't allowed. You'll play unnamed.",
  'notice.skinRejected': "That skin isn't available.",
  'notice.cannotSpectate': "You can't watch while you're playing.",
  'notice.brQueued': "A battle is in progress. You'll join the next one.",
  'notice.respawnIn': 'Respawning in {s}',
  // --- territory arena (territory-ui.md §8: all copy is ours) ---
  'arena.unnamed': 'Unnamed',
  // Arena skins (territory-visuals.md §14): names and picker copy are ours.
  'arena.skins.button': 'Skin: {name}',
  'arena.skins.title': 'Pick a skin',
  'arena.skins.hint':
    'Your colour changes every life. A skin adds a pattern to your land and a look to your head.',
  'arena.skins.done': 'Done',
  'arena.skin.none': 'Plain',
  'arena.skin.dots': 'Polka',
  'arena.skin.stripes': 'Candy Stripe',
  'arena.skin.checks': 'Picnic',
  'arena.skin.waves': 'Tide',
  'arena.skin.chevron': 'Arrowhead',
  'arena.skin.scales': 'Scales',
  'arena.skin.bricks': 'Brickwork',
  'arena.skin.confetti': 'Confetti',
  'arena.skin.stars': 'Starry',
  'arena.skin.tartan': 'Tartan',
  'arena.skin.terrazzo': 'Terrazzo',
  'arena.skin.circuit': 'Circuit',
  'arena.skin.leaves': 'Sprout',
  'arena.skin.flakes': 'Frost',
  'arena.skin.peeper': 'Peeper',
  'arena.skin.visor': 'Visor',
  'arena.tip.invite': "Draw a loop. Keep what's inside.",
  'arena.tip.controls': 'Point the mouse to steer.',
  'arena.tip.controlsTouch': 'Drag anywhere to steer.',
  'arena.tip.rule': 'Out of your land, your trail is your weak spot.',
  'arena.tip.money': "Cross a trail to take that player's whole bag.",
  'arena.onboard.title': 'How to take land',
  'arena.onboard.steer': 'Steer with the mouse (or drag).',
  'arena.onboard.steerTouch': 'Drag anywhere to steer.',
  'arena.onboard.loop': 'Leave your land and come back to take more.',
  'arena.onboard.trail': 'Never touch a trail, yours or theirs.',
  'arena.onboard.cash': 'Hold {key} outside your land for {s} s to cash out.',
  'arena.onboard.cashTouch': 'Hold $ outside your land for {s} s to cash out.',
  'arena.onboard.gotIt': 'Got it',
  'arena.float.kill': "Got 'em!",
  'arena.feed.cut': '{killer} cut {victim} · {usd}',
  'arena.feed.enclosed': '{killer} enclosed {victim} · {usd}',
  'arena.feed.starved': '{killer} starved {victim} · {usd}',
  'arena.feed.spill': '{victim} crashed · {usd} dropped',
  'arena.notice.shieldOn': 'Shielded',
  'arena.notice.shieldOnDetail': "Your land can't be taken for {s} s",
  'arena.notice.shieldOff': 'Shield off',
  'arena.notice.shieldOffDetail': 'Your land can be taken now',
  'arena.notice.leaveLand': 'Leave your land to cash out',
  'arena.notice.leaveLandDetail': 'The cash-out only fills outside your land',
  'arena.notice.finding': 'Finding a spot…',
  'arena.notice.findingDetail': 'Looking for open ground',
  'arena.notice.idle': 'Still there?',
  'arena.notice.idleDetail': 'Steer within {s} s or your bag is cashed out for you',
  'arena.notice.autopilot': 'Auto-exit',
  'arena.notice.autopilotDetail': 'Steering your head out to bank your bag',
  'arena.result.cut': 'Cut by {name}',
  'arena.result.enclosed': 'Enclosed by {name}',
  'arena.result.starved': 'Starved by {name}',
  'arena.result.self': 'You crossed your own trail',
  'arena.result.selfWall': 'You doubled back into your trail at the wall',
  'arena.result.banked': 'Banked {usd}',
  'arena.result.auto': 'Auto-exit: banked {usd}',
  'arena.result.lost': 'Lost {usd} to {name}',
  'arena.result.dropped': 'Dropped {usd}',
  'arena.result.maxLand': 'Max land',
  'arena.result.newBest': 'new best',
  'arena.result.outcome': 'Outcome',
  'arena.result.money': 'Money',
  'arena.result.timeKillsLabel': 'Time · Kills',
  'arena.result.timeKills': '{time} · {n} kills',
  'arena.hud.best': 'best {pct}',
  'arena.hud.kills': '×{n}',
  'arena.hud.land': 'Land',
  'arena.hud.minimap': 'Map',
  'arena.hud.cashOut': 'Hold to cash out',
  'arena.ui.continue': 'Continue',
  'arena.ui.again': 'Play again',
  // --- territory-first home (our identity and copy) ---
  'home.tagline': 'Loop out. Come home. Own the map.',
  'home.play': 'Play',
  'home.playSub': 'Free · bots and players · no sign-in',
  'home.playMoney': 'Play for money',
  'home.playMoneySoon': 'Play for money · coming soon',
  'home.playMoneySub': 'Cut a trail, take the whole bag',
  'home.classic': 'Classic',
  'home.classicSub': 'The free cell-eating game',
  'home.backToTerritory': 'Territory',
  'home.howto.title': 'How it works',
  'home.howto.1': 'Leave your land and draw a loop.',
  'home.howto.2': 'Come back home: everything inside is yours.',
  'home.howto.3': 'Touch any trail and that player is out.',
  'home.noArena': 'The territory arena is warming up on this server: you are in practice.',
  // --- arena settings (territory-ui.md §7) ---
  'settings.arenaSteer': 'Territory steering (touch)',
  'settings.arenaSteer.stick': 'Stick',
  'settings.arenaSteer.point': 'Point',
  'settings.arenaMinimapAll': 'Show all territory on minimap',
  'settings.arenaAlarm': 'Alarm when someone enters your land',
} as const;

export type EnTable = typeof EN;
